"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var of_1 = require("rxjs/observable/of");
var meta_knowledge_provider_service_1 = require("../api/meta-knowledge-provider.service");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var filter_config_1 = require("../../../controls/party-picker/model/filter-config");
var filter_settings_1 = require("../../../controls/party-picker/model/filter-settings");
var filtered_party_1 = require("../../../controls/party-picker/model/filtered-party");
var operators_1 = require("rxjs/operators");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var zip_1 = require("rxjs/observable/zip");
var static_method_1 = require("../../utils/static-method");
var HttpPartyPickerProviderService = /** @class */ (function () {
    function HttpPartyPickerProviderService(metaKnowledgeProviderService, kbService, currentLanguageProvider) {
        this.metaKnowledgeProviderService = metaKnowledgeProviderService;
        this.kbService = kbService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.nameMetaFieldIds = [];
    }
    HttpPartyPickerProviderService.prototype.getPartyFilterFunctions = function (rootCategory) {
        var _this = this;
        return this.metaKnowledgeProviderService.getPartyDefinitions(rootCategory).pipe(operators_1.switchMap(function (partyDefinitions) {
            if (partyDefinitions) {
                return of_1.of(_this.getDefaultPartyFilters(partyDefinitions, rootCategory));
            }
            else {
                return of_1.of([]);
            }
        }));
    };
    HttpPartyPickerProviderService.prototype.provide = function (filterConfigs, rootEntity, partyDefinitions) {
        var _this = this;
        var nameMetaFieldIds$ = this.kbService.getNameMetaFieldIds(partyDefinitions.category);
        var currentLanguage$ = this.currentLanguageProvider.getCurrentLanguage();
        return zip_1.zip(nameMetaFieldIds$, currentLanguage$).pipe(operators_1.map(function (_a) {
            var nameMetaFieldIds = _a[0], currentLanguage = _a[1];
            _this.nameMetaFieldIds = nameMetaFieldIds.map(function (metaFieldId) { return metaFieldId.getSystemName(); });
            _this.currentLanguageId = currentLanguage.getId();
            var parties = [];
            filterConfigs.forEach(function (filterConfig) {
                switch (filterConfig.key) {
                    case 'parties':
                        parties.push.apply(parties, _this.getFilteredParties(rootEntity, partyDefinitions, filterConfig));
                        break;
                    case 'participants':
                        parties.push.apply(parties, _this.getFilteredParticipants(rootEntity, partyDefinitions, filterConfig));
                        break;
                    case 'advocates':
                        parties.push.apply(parties, _this.getFilteredAdvocates(rootEntity, partyDefinitions, filterConfig));
                        break;
                    case 'representatives':
                        parties.push.apply(parties, _this.getFilteredRepresentatives(rootEntity, partyDefinitions, filterConfig));
                }
            });
            return _this.sortParties(parties);
        }));
    };
    HttpPartyPickerProviderService.prototype.getDefaultPartyFilters = function (partyDefinitions, rootCategoryId) {
        var defaultPartyFilters = [];
        var rootCategoryInSnakeCase = static_method_1.convertToSnakeCase(rootCategoryId);
        if (partyDefinitions.parties) {
            defaultPartyFilters.push(new filter_settings_1.FilterSettings('parties', "ejustice_" + rootCategoryInSnakeCase + "_parties", "ejustice_" + rootCategoryInSnakeCase + "_parties_description", new filter_config_1.FilterConfig('parties', null, null, [], [], [], false), false, true, true, true, true));
        }
        if (partyDefinitions.participants) {
            defaultPartyFilters.push(new filter_settings_1.FilterSettings('participants', "ejustice_" + rootCategoryInSnakeCase + "_participants", "ejustice_" + rootCategoryInSnakeCase + "_participants_description", new filter_config_1.FilterConfig('participants', null, null, [], [], [], false), false, true, true, true, true));
        }
        if (partyDefinitions.advocates) {
            defaultPartyFilters.push(new filter_settings_1.FilterSettings('advocates', "ejustice_" + rootCategoryInSnakeCase + "_advocates", "ejustice_" + rootCategoryInSnakeCase + "_advocates_description", new filter_config_1.FilterConfig('advocates', null, null, [], [], [], false), false, false, true, false, true));
        }
        if (partyDefinitions.partyRepresentativeField) {
            defaultPartyFilters.push(new filter_settings_1.FilterSettings('representatives', "ejustice_" + rootCategoryInSnakeCase + "_representatives", "ejustice_" + rootCategoryInSnakeCase + "_representatives_description", new filter_config_1.FilterConfig('representatives', null, null, [], [], [], false), false, true, true, true, true));
        }
        return defaultPartyFilters;
    };
    HttpPartyPickerProviderService.prototype.getFilteredParties = function (rootEntity, partyDefinitions, filterConfig) {
        return this.getRootEntityFilteredParties(rootEntity, filterConfig, partyDefinitions, partyDefinitions.parties.field, partyDefinitions.parties.partyField, partyDefinitions.parties.roleField)
            .map(function (partySubEntity) {
            var party = partySubEntity.getProperty(partyDefinitions.parties.partyField).value;
            var role = partySubEntity.getProperty(partyDefinitions.parties.roleField).value;
            return new filtered_party_1.FilteredParty(party.getInstanceId(), party, role);
        });
    };
    HttpPartyPickerProviderService.prototype.getFilteredParticipants = function (rootEntity, partyDefinitions, filterConfig) {
        var participants = this.getRootEntityFilteredParties(rootEntity, filterConfig, partyDefinitions, partyDefinitions.participants.field, partyDefinitions.participants.participantField, partyDefinitions.participants.roleField);
        var filteredParticipants = [];
        participants.forEach(function (participantSubEntity) {
            var participant = participantSubEntity.getProperty(partyDefinitions.participants.participantField).value;
            var party = participantSubEntity.hasProperty(partyDefinitions.participants.partyField) &&
                participantSubEntity.getProperty(partyDefinitions.advocates.partyField).value;
            if (party) {
                var role = participantSubEntity.getProperty(partyDefinitions.participants.roleField).value;
                filteredParticipants.push(new filtered_party_1.FilteredParty(participant.getInstanceId(), participant, role));
            }
            else {
                console.warn("Skipping Participant with id: " + participant.getInstanceId() + " \n Reason: Participants must have a related Party");
            }
        });
        return filteredParticipants;
    };
    HttpPartyPickerProviderService.prototype.getFilteredAdvocates = function (rootEntity, partyDefinitions, filterConfig) {
        var advocates = this.getRootEntityFilteredParties(rootEntity, filterConfig, partyDefinitions, partyDefinitions.advocates.field, partyDefinitions.advocates.advocateField);
        var filteredAdvocates = new Map();
        advocates.forEach(function (advocateSubEntity) {
            var advocate = advocateSubEntity.getProperty(partyDefinitions.advocates.advocateField).value;
            var party = advocateSubEntity.hasProperty(partyDefinitions.advocates.partyField) &&
                advocateSubEntity.getProperty(partyDefinitions.advocates.partyField).value;
            if (party) {
                filteredAdvocates.set(advocate.getInstanceId(), new filtered_party_1.FilteredParty(advocate.getInstanceId(), advocate, null));
            }
            else {
                console.warn("Skipping Advocate with id: " + advocate.getInstanceId() + " \n Reason: Advocates must have a related Party");
            }
        });
        return Array.from(filteredAdvocates.values());
    };
    HttpPartyPickerProviderService.prototype.getFilteredRepresentatives = function (rootEntity, partyDefinitions, filterConfig) {
        var filteredParties = this.getRootEntityFilteredParties(rootEntity, filterConfig, partyDefinitions, partyDefinitions.parties.field, partyDefinitions.parties.partyField, partyDefinitions.parties.roleField);
        var filteredParticipants = this.getRootEntityFilteredParties(rootEntity, filterConfig, partyDefinitions, partyDefinitions.participants.field, partyDefinitions.participants.participantField, partyDefinitions.participants.roleField);
        var filteredAdvocates = this.getRootEntityFilteredParties(rootEntity, filterConfig, partyDefinitions, partyDefinitions.advocates.field, partyDefinitions.advocates.advocateField);
        var representatives = new Map();
        filteredParties.forEach(function (partySubEntity) {
            if (partySubEntity.hasProperty(partyDefinitions.partyRepresentativeField) && partySubEntity.getProperty(partyDefinitions.partyRepresentativeField).value) {
                var representativeParty = partySubEntity.getProperty(partyDefinitions.partyRepresentativeField).value;
                representatives.set(representativeParty.getInstanceId(), new filtered_party_1.FilteredParty(representativeParty.getInstanceId(), representativeParty, null));
            }
        });
        filteredParticipants.forEach(function (participantSubEntity) {
            if (participantSubEntity.hasProperty(partyDefinitions.partyRepresentativeField) && participantSubEntity.getProperty(partyDefinitions.partyRepresentativeField).value) {
                var representativeParty = participantSubEntity.getProperty(partyDefinitions.partyRepresentativeField).value;
                representatives.set(representativeParty.getInstanceId(), new filtered_party_1.FilteredParty(representativeParty.getInstanceId(), representativeParty, null));
            }
        });
        filteredAdvocates.forEach(function (advocateSubEntity) {
            if (advocateSubEntity.hasProperty(partyDefinitions.partyRepresentativeField) && advocateSubEntity.getProperty(partyDefinitions.partyRepresentativeField).value) {
                var representativeParty = advocateSubEntity.getProperty(partyDefinitions.partyRepresentativeField).value;
                representatives.set(representativeParty.getInstanceId(), new filtered_party_1.FilteredParty(representativeParty.getInstanceId(), representativeParty, null));
            }
        });
        return Array.from(representatives.values());
    };
    HttpPartyPickerProviderService.prototype.getRootEntityFilteredParties = function (rootEntity, filterConfig, partyDefinitions, subEntityField, partyField, roleField) {
        var _this = this;
        var subEntities = rootEntity.getProperty(subEntityField).value;
        var totalFilteredSubEntities = new Set();
        var filteredSubEntities = subEntities.filter(function (subEntity) { return _this.checkSubEntityByFilter(subEntity, filterConfig, partyDefinitions, partyField, roleField); });
        filteredSubEntities.forEach(function (subEntity) { return totalFilteredSubEntities.add(subEntity); });
        return Array.from(totalFilteredSubEntities.values());
    };
    HttpPartyPickerProviderService.prototype.checkSubEntityByFilter = function (subEntity, filterConfig, partyDefinitions, partyField, roleField) {
        var party = subEntity.getProperty(partyField).value;
        var hasStateField = party.hasProperty('WFStateID');
        var typeId = party.getProperty(partyDefinitions.type.field).value.getId();
        var stateId = hasStateField && party.getProperty('WFStateID').value.getId();
        var isActive = subEntity.getProperty(partyDefinitions.isActiveField).value;
        var roleId = roleField && subEntity.getProperty(roleField).value.getId();
        var compliesWithRole = !filterConfig.partyRoleIds.length || (roleId && filterConfig.partyRoleIds.includes(roleId));
        var compliesWithType = !filterConfig.partyTypeIds.length || (typeId && filterConfig.partyTypeIds.includes(typeId));
        var compliesWithState = !hasStateField || !filterConfig.partyStateIds.length || (roleId && filterConfig.partyStateIds.includes(stateId));
        var compliesWithIsActive = filterConfig.includeInactiveParties || isActive; // TODO: wired naming?
        return compliesWithRole && compliesWithType && compliesWithState && compliesWithIsActive;
    };
    HttpPartyPickerProviderService.prototype.getName = function (party) {
        var _this = this;
        return this.nameMetaFieldIds.map(function (nameMetaFieldId) {
            var name = party.getProperty(nameMetaFieldId).value;
            return name instanceof idm_crosscutting_concepts_frontend_1.MultilingualString ? name.getValue(_this.currentLanguageId) : name;
        }).join(' ');
    };
    HttpPartyPickerProviderService.prototype.sortParties = function (parties) {
        var _this = this;
        return parties.sort(function (a, b) {
            var nameA = _this.getName(a.entity).toLowerCase();
            var nameB = _this.getName(b.entity).toLowerCase();
            return nameA.localeCompare(nameB);
        });
    };
    HttpPartyPickerProviderService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [meta_knowledge_provider_service_1.MetaKnowledgeProviderService, idm_kb_service_client_js_1.KbService, idm_session_data_provider_api_js_1.CurrentLanguageProvider])
    ], HttpPartyPickerProviderService);
    return HttpPartyPickerProviderService;
}());
exports.HttpPartyPickerProviderService = HttpPartyPickerProviderService;
//# sourceMappingURL=http-party-picker-provider.service.js.map